// AssignPingingWeb.jsx

import PingingDataTable from "../../components/PingingDataTable/PingingDataTable";

const AssignPingingWeb = () => {
  return (
    <PingingDataTable
      title="Pinging Report - Lesson Pages"
      apiEndpoint="/pinging-assignment"
      defaultValue="web_all"
      showVideoColumns={false}
      showPlayVideo={false}
      type="assign"
      pingType="web"
      toolId={7}
    />
  );
};

export default AssignPingingWeb;
